export const DEFAULT_SEARCH_RADIUS = 50000; // 50km (max radius for Google Nearby Search);

export const defaultPolylineOptions = {
  strokeColor: "#FF0000",
  strokeOpacity: 0.8,
  strokeWeight: 2,
  fillColor: "#FF0000",
  fillOpacity: 0.35,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 30000,
  paths: [
    { lat: 37.772, lng: -122.214 },
    { lat: 21.291, lng: -157.821 },
    { lat: -18.142, lng: 178.431 },
    { lat: -27.467, lng: 153.027 },
  ],
  zIndex: 1,
};

export const NIGHT_BREAKTIME_IN_MINUTES = 16 * 60; // 16 hours
export const START_OF_THE_DAY_BREAKTIME_IN_MINUTES = 24 * 60;

export const WEEKDAYS = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const GENERAL_ROUTE_INDEX = 123;

export const DEFAULT_ROUTE_DAY_HOURS = 9.5;

export const TAGS_WITHOUT_TIMETABLE = ["Lake"];

export const PostMessageKeys = Object.freeze({
  RoutesList: {
    ChangeHeight: "routesList-changeHeight",
    ScrollToTop: "routesList-scrollToTop",
  },
  RouteBuilder: {
    Email: "routeBuilder-email",
    ChangeHeight: "routeBuilder-changeHeight",
    ScrollToTop: "routeBuilder-scrollToTop",
    CloseButtonVisibility: "routeBuilder-closeBtnVisibility",
  },
});
